import React, { Fragment } from 'react'
import {AppGridBar,AppGridTabs,AppButton,AppRow} from 'qcc'
import { Row, Icon } from 'antd';


export const AppGridBarDemo = () =>{
    return (<div className='app-demo-content'>
            <h1>使用说明</h1>    
            <div>
                1、与AppTable组合使用。<br/>
                2、分为左边区域，和右边区域<br/>
                3、右边区域为按钮区域，左边用于视图或则标题使用<br/>
                4、引用：import {`{AppGridBar}`} from 'qcc'<br/>
                5、demo位置：src/demo/components/AppGridBarDemo.tsx
            </div>

            <h1>DEMO</h1>
            <div className='app-demo-content-demo'>
                <div style={{padding:10}}>
                    <AppGridBar>
                        <AppGridBar.Left>
                            <AppGridTabs tabs={['视图1','视图2','视图3','视图4']}/>
                        </AppGridBar.Left>
                        <AppGridBar.Right>
                            <AppRow style={{float:'right',marginRight:20}}>
                                <AppButton label='primary' type='primary'/>
                                <AppButton label='default'/>
                                <AppButton label='更多操作'>
                                    <AppButton.Item label='操作1'/>
                                    <AppButton.Item label='操作2'/>
                                    <AppButton.Item label='操作3'/>
                                    <AppButton.Item label='操作4'/>
                                </AppButton>
                            </AppRow>
                        </AppGridBar.Right>
                    </AppGridBar>
                </div>
            </div>
        
    </div>)
}


// WEBPACK FOOTER //
// ./src/demo/components/AppGridBarDemo.tsx